import { render, staticRenderFns } from "./BookingGeneralSetupForm.vue?vue&type=template&id=606a06f2&scoped=true&"
import script from "./BookingGeneralSetupForm.vue?vue&type=script&lang=js&"
export * from "./BookingGeneralSetupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a06f2",
  null
  
)

export default component.exports